import { AsYouType, CountryCode } from 'libphonenumber-js';

export const getFormattedNumber = (countryCode: CountryCode, phoneNumber: string) => {
  return new AsYouType(countryCode).input(phoneNumber);
};
